import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { EnquiryForm } from "@/components/EnquiryForm";

export const ConsultationModal = ({ open, onOpenChange }) => {
  const [sent, setSent] = useState(false);

  const handleChange = (v) => {
    onOpenChange(v);
    if (!v) setTimeout(() => setSent(false), 300);
  };

  return (
    <Dialog open={open} onOpenChange={handleChange}>
      <DialogContent
        data-testid="consultation-modal"
        className="max-w-lg rounded-3xl border-navy/10 bg-cream"
      >
        {sent ? (
          <div className="flex flex-col items-center py-8 text-center" data-testid="consultation-success">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-sage-light text-sage-dark">
              <CheckCircle2 className="h-8 w-8" aria-hidden="true" />
            </span>
            <h3 className="mt-5 font-serif text-2xl text-navy">Enquiry received</h3>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-charcoal/70">
              Thank you for reaching out. Our care coordinator will be in touch within
              24 hours to arrange your free, unhurried consultation.
            </p>
            <button
              type="button"
              onClick={() => handleChange(false)}
              data-testid="consultation-success-close"
              className="mt-7 rounded-full bg-navy px-8 py-3 text-sm font-semibold text-cream transition-colors hover:bg-mauve-dark"
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="font-serif text-2xl text-navy">
                Book a free consultation
              </DialogTitle>
              <DialogDescription className="text-sm leading-relaxed text-charcoal/70">
                A few quick details and our care coordinator will call you back within
                24 hours — no pressure, no obligation.
              </DialogDescription>
            </DialogHeader>
            <EnquiryForm
              compact
              idPrefix="consultation"
              submitTestId="consultation-modal-submit-button"
              onSuccess={() => setSent(true)}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
